"use client";

import { Button } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";
import { createPortal } from "react-dom";

/**
 * Full-page overlay that appears when an account mismatch is detected between zapier.com
 * and mcp.zapier.com sessions
 */
export const AccountMismatchBanner = () => {
  const handleRefresh = () => {
    window.location.href = "/mcp";
  };

  return createPortal(
    <div
      className="fixed inset-0 z-50 bg-white flex items-center justify-center"
      role="alert"
      aria-live="assertive"
    >
      <div className="bg-gray-warm-1 rounded-lg border-2 border-dashed border-gray-warm-4 py-4 px-8 max-w-lg text-center flex flex-col items-center">
        <div className="flex justify-center mb-6">
          <Icon name="personGroupFill" size="48" className="text-gray-warm-5" />
        </div>

        <h1 className="text-xl font-semibold text-gray-warm-9 mb-2">
          You switched organizations
        </h1>

        <p className="text-sm text-gray-warm-6 mb-6">
          We noticed you switched organizations in another tab. Refresh to keep
          working in your new one.
        </p>

        <Button variant="primary" onClick={handleRefresh}>
          Refresh now
        </Button>
      </div>
    </div>,
    document.body,
  );
};
